import axios from '../../axios';
import {
   ADD_STOCK_TRANSFER,
   UPDATE_STOCK_TRANSFER,
   DELETE_STOCK_TRANSFER,
   GET_STOCK_TRANSFER,
   GET_STOCK_TRANSFER_BY_ID,
   GET_STOCK_TRANSFER_LAST_DOCNO,
   MULTI_DELETE_ACCOUNT,
} from '../types';
import { toast } from 'react-toastify';

export const getStockTransfer = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/stock-transfer/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_STOCK_TRANSFER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getStockTransferLastDoc = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/stock-transfer/last-docNo', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_STOCK_TRANSFER_LAST_DOCNO,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getStockTransferById = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/account/${id}`);
      const res = await axios.get('/stock-transfer', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_STOCK_TRANSFER_BY_ID, payload: res.data.data, single: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.log('err', err.response);
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const addStockTransfer = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/stock-transfer/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_STOCK_TRANSFER, payload: res.data.data });
         localStorage.setItem('accountId', res?.data?.data?.id);
         localStorage.setItem('accountData', JSON.stringify(res?.data?.data));
         setTimeout(() => {
            toast.success('Stock Transfer added successfully!');
         }, 1000);
         return res.data;
      } else {
         toast.error('Failed to add Stock Transfer. Please try again.');
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateStockTransfer = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/stock-transfer/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_STOCK_TRANSFER, payload: res.data.data });

         setTimeout(() => {
            toast.success('Stock Transfer updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// Delete Customer
export const deleteStockTransfer = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/stock-transfer/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_STOCK_TRANSFER, payload: { id } });
         toast.success('Stock Transfer deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// export const multiDeleteCustomer = (formData) => async (dispatch) => {
//    try {
//       const res = await axios.post(`/account/delete/multi`, formData);

//       if (res.data.code === 1) {
//          dispatch({ type: MULTI_DELETE_ACCOUNT, payload: res.data.data });

//          setTimeout(() => {
//             toast.success('Account deleted successfully!');
//          }, 1000);
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err.response.data.errors[0].message) {
//          toast.error(err.response.data.errors[0].message);
//       }
//    }
// };
